import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Callback for the custom Google OAuth flow: Google redirects here with ?code=&state=.
const GoogleCallback = () => {
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const run = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get("code");
            const state = params.get("state");
            const expectedState = sessionStorage.getItem("cc_oauth_state");
            sessionStorage.removeItem("cc_oauth_state");
            const intentRole = sessionStorage.getItem("cc_intent_role");
            sessionStorage.removeItem("cc_intent_role");

            if (!code || !state || state !== expectedState) {
                navigate("/login", { replace: true });
                return;
            }
            try {
                const r = await api.post("/auth/google/exchange", {
                    code,
                    redirect_uri: window.location.origin + "/auth/google",
                });
                await refresh();
                const role = r.data.role;
                if (role && role !== "unset") {
                    navigate(`/${role}/dashboard`, { replace: true });
                } else {
                    navigate(intentRole ? `/role?role=${intentRole}` : "/role", { replace: true });
                }
            } catch {
                navigate("/login", { replace: true });
            }
        };
        run();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen bg-yc-cream flex items-center justify-center">
            <div className="yc-card p-10 text-center">
                <div className="font-heading text-2xl font-black tracking-tight">Signing you in…</div>
                <p className="text-sm text-yc-ink/60 mt-2">One moment.</p>
            </div>
        </div>
    );
};

export default GoogleCallback;
